export default function initRolexVideos(): void {
  const videoElements = document.querySelectorAll<HTMLElement>('.rolex-video');
  if (!videoElements.length) return;

  function loadYouTubeApi(callback: () => void) {
    if ((window as any).YT?.Player) {
      callback();
    } else {
      window.onYouTubeIframeAPIReady = callback;
      const tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/player_api';
      const firstScript = document.getElementsByTagName('script')[0];
      firstScript?.parentNode?.insertBefore(tag, firstScript);
    }
  }

  function initializePlayers() {
    videoElements.forEach((videoWrapperEl) => {
      const videoPlayerEl = videoWrapperEl.querySelector<HTMLElement>('.rolex-video__player') as HTMLElement;
      const videoId = videoPlayerEl.dataset.videoid;
      const backdrop = videoWrapperEl.querySelector<HTMLElement>('.rolex-video__backdrop') as HTMLElement;
      let isPlaying = false;

      const player = new window.YT.Player(videoPlayerEl, {
        videoId,
        playerVars: {
          autoplay: 0,
          rel: 0,
          color: 'white'
        },
        events: {
          onReady: () => {
            backdrop.addEventListener('click', () => {
              if (!isPlaying) {
                try {
                  player.playVideo();
                  isPlaying = true;
                  backdrop.classList.add('hide');
                } catch (error) {
                  console.error('Error playing video:', error);
                }
              }
            });
          },
          onError: (event) => {
            console.error('YouTube player error:', event.data);
          }
        }
      });
    });
  }

  loadYouTubeApi(initializePlayers);
}
